import Link from 'next/link'
import styled from 'styled-components'
import Check from 'src/components/icons/Check'
import { Detail } from 'src/styles/Typography'
import grabColor from 'src/utils/grabColor'

function Author({ author, publishedAt, expertVerified }) {
  return (
    <AuthorWrapper>
      <div>
        <Writer>By {author?.fullName || 'Allison Jameson'}</Writer>
        <Details>
          {publishedAt && (
            <span>
              Updated{' '}
              {new Date(publishedAt).toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              })}
            </span>
          )}
        </Details>
      </div>
      {expertVerified && expertVerified.name && expertVerified.link && (
        <ExpertVerifiedWrapper>
          <ExpertVerified>
            <Check />
            Expert Verified
          </ExpertVerified>
          <Detail>
            By{' '}
            <Link href={expertVerified.link} target="__blank" legacyBehavior>
              {expertVerified.name}
            </Link>
          </Detail>
        </ExpertVerifiedWrapper>
      )}
    </AuthorWrapper>
  );
}

export default Author

const ExpertVerifiedWrapper = styled.div`
  ${Detail} {
    margin: 5px 0;
    text-align: right;
    a {
      font-weight: 600;
      color: ${grabColor('detail')};
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

const Writer = styled.div`
  font-family: Libre Baskerville;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  color: ${grabColor('heading')};
`

const ExpertVerified = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.action.DEFAULT};
  color: white;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  border-radius: 100px;
  padding: 0px 10px;
  height: 24px;

  svg {
    margin-right: 6px;
  }
`

const AuthorWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0 0 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

const Details = styled.div`
  color: ${grabColor('detail')};
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${grabColor('detail')};
`
